/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-03-31 15:22:08
 * @FilePath: /app-monorepo-projects/packages/app-share/src/composable/use-initialize-home-data/use-init-csr.ts
 */
import { MutationTypes, useStore } from '@/store';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useShareStrategyMethod from '@/composable/use-request-data-method/fetch-share-strategy';
import useGetCommonMethods from '@/composable/use-get-common-method';
import { fetchFeedDetailCSR } from '@/services/fetch-feed-detail';
import { fetchDramaFeed } from '@/services/fetch-hot-dramas';
import { fetchUserInfoCSR } from '@/services/fetch-user-info';
import { fetchCollectionFeedsCSR } from '@/services/fetch-collection-feeds';
import { ECollectionStyle } from '@/constants/share';

export default function useInitializeInCsr() {
  const store = useStore();
  const { state } = store;
  const { info: urlInfo } = useProvideUrlInfo();
  const fetchShareStrategy = useShareStrategyMethod();
  const { getGrowthTestDataFromRes } = useGetCommonMethods();

  /**
   * @description: 初始化普通视频数据
   * @return {*}
   */
  async function initializeNormalFeed() {
    const { id: feedId, dramaid: dramaId } = urlInfo.query;
    if (!feedId) return;
    const res = await fetchFeedDetailCSR({
      feedid: feedId,
      dataType: 0, // 代表内容类型，在端外分享页，该值固定为0
    });

    if (res.feeds?.length) {
      store.commit(MutationTypes.SET_FEEDS_LIST, { value: res.feeds });
      store.commit(MutationTypes.SET_IS_COLLECTION, {
        value: false,
      });
    }

    // 是否短剧
    if (dramaId) {
      store.commit(MutationTypes.SET_IS_DRAMA, { value: true });
      const dramaRes = await fetchDramaFeed({
        dramaID: dramaId,
      });

      if (dramaRes?.drama) {
        store.commit(MutationTypes.SET_DRAMA_LIST, { value: [dramaRes?.drama] });
      }
    }
    // 如果出现异常
    if (res?.errMsg) {
      store.commit(
        MutationTypes.SET_ERROR_MSG
        , { value: res?.errMsg },
      );
    }
  }

  /**
   * @description: 初始化普通视频数据
   * @return {*}
   */
  async function initializeCollectionFeeds() {
    const { id: feedId, collectionid: collectionId } = urlInfo.query;
    if (!feedId || !collectionId) return;
    const { feedList, collection } = await fetchCollectionFeedsCSR({
      collectionId,
      feedId,
    });
    // 初始化精选集相关的数据
    if (feedList?.length) {
      store.commit(
        MutationTypes.INITIALIZE_COLLECTION_DATA
        , { value: { feedList, collection, feedId } },
      );
    }
    // 这里降级至普通视频
    await initializeNormalFeed();
    store.commit(MutationTypes.SET_SHOW_COLLECTION, {
      value: false,
    });
  }

  /**
   * @description: 初始化feed相关数据
   * @return {*}
   */
  async function initializeFeed() {
    const { id: feedId, collectionid: collectionId } = urlInfo.query;
    if (!feedId) {
      return store.commit(MutationTypes.SET_ERROR_MSG, {
        value: '无效feed',
      });
    }
    // 是否是精选集
    if (collectionId) {
      await initializeCollectionFeeds();
    } else {
      await initializeNormalFeed();
    }
  };
  /**
   * @description: 初始化banner相关数据
   * @return {*}
   */
  async function initializeBanner() {
    const { spid: sharePersonId } = urlInfo.query;
    if (!sharePersonId) return;
    const person = await fetchUserInfoCSR({
      personId: sharePersonId,
    });
    // banner里面包含person，这里只设置person值
    store.commit(MutationTypes.SET_BANNER, { value: { ...(state.banner || {}), person } });
  }
  /**
   * @description: 初始化分享策略数据
   * @return {*}
   */
  async function initializeShareStrategy() {
    const { collectionid: collectionId } = urlInfo.query;
    const res = await fetchShareStrategy({
      isWsInstalled: false,
    });

    if (res) {
      const isNewUI = res.collectionStyle === ECollectionStyle.newUI;
      store.commit(MutationTypes.SET_SHOW_COLLECTION, {
        value: collectionId && !isNewUI, // 老的精选集样式，需要直接展示精选集，新的精选集则需要隐藏
      });
      store.commit(MutationTypes.SET_GROWTHTEST_DATA, {
        value: getGrowthTestDataFromRes(res),
      });
      store.commit(MutationTypes.SET_IS_NEWUI, {
        value: isNewUI,
      });
    };
  }
  /**
   * @description: 在csr过程中，需要初始化的数据
   * @return {*}
   */
  async function initializeInCsr() {
    const initializeFeedPromise = initializeFeed();
    const initializeBannerPromise = initializeBanner();
    const iinitializeShareStrategyPromise = initializeShareStrategy();
    // 并行调用接口
    await initializeFeedPromise;
    await initializeBannerPromise;
    await iinitializeShareStrategyPromise;
  };
  return {
    initializeFeed,
    initializeBanner,
    initializeShareStrategy,
    initializeInCsr,
  };
};
